<form [formGroup]="fridgestorageFormGroup">
  <div class="p-fluid formgrid grid">

    <div class="field col-12 lg:col-6">
      <label for="fridgestorageName">
        {{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.NameFieldLabel' | translate}} *
      </label>
      <input
        id="fridgestorageName"
        formControlName="fridgestorageName"
        type="text"
        pInputText
        [maxlength]="300"
        required
        autofocus
        class="custom-input"
        placeholder="{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.NameFieldPlaceholder' | translate}}"/>
      <small *ngIf="submit && fridgestorageFormGroup.controls['fridgestorageName'].invalid"
        class="p-error">{{getErrorMessage(fridgestorageFormGroup, 'fridgestorageName')}}</small>
    </div>

    <div class="field col-12 lg:col-6">
      <label for="fridgestorageVat">
        {{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.VatFieldLabel' | translate}}
      </label>
      <input
        id="fridgestorageVat"
        pInputText formControlName="fridgestorageVat"
        [maxlength]="20"
        class="custom-input"
        placeholder="{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.VatFieldPlaceholder' | translate}}"/>
    </div>

    <div class="field col-12 lg:col-6">
      <label for="fridgestorageFDA">
        {{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.FDAFieldLabel' | translate}}
      </label>
      <input
        id="fridgestorageFDA"
        pInputText formControlName="fridgestorageFDA"
        [maxlength]="20"
        class="custom-input"
        placeholder="{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.FDAFieldPlaceholder' | translate}}"/>
    </div>

    <div class="field col-12 lg:col-6">
      <label for="fridgestorageContactName">
        {{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.ContactNameFieldLabel' | translate}} *
      </label>
      <input
        id="fridgestorageContactName"
        formControlName="fridgestorageContactName"
        type="text"
        [maxlength]="300"
        pInputText
        required
        class="custom-input"
        placeholder="{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.ContactNameFieldPlaceholder' | translate}}"/>
      <small *ngIf="submit && fridgestorageFormGroup.controls['fridgestorageContactName'].invalid"
        class="p-error">{{getErrorMessage(fridgestorageFormGroup, 'fridgestorageContactName')}}</small>
    </div>

    <div class="field col-12 lg:col-6">
      <label for="fridgestorageContactEmail">
        {{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.ContactEmailFieldLabel' | translate}} *
      </label>
      <input
        id="fridgestorageContactEmail"
        formControlName="fridgestorageContactEmail"
        type="text"
        [maxlength]="100"
        pInputText
        required
        class="custom-input"
        placeholder="{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.ContactEmailFieldPlaceholder' | translate}}"/>
      <small *ngIf="submit && fridgestorageFormGroup.controls['fridgestorageContactEmail'].invalid"
        class="p-error">
        {{getErrorMessage(fridgestorageFormGroup, 'fridgestorageContactEmail')}}</small>
    </div>

    <div class="field col-12 lg:col-6">
      <label for="fridgestorageContactAddress">
        {{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.FactoryAddressLabel' | translate}} *
      </label>
      <input
        id="fridgestorageContactAddress"
        formControlName="fridgestorageContactAddress"
        type="text"
        [maxlength]="300"
        pInputText
        required
        class="custom-input"
        placeholder="{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.FactoryAddressPlaceholder' | translate}}"/>
      <small *ngIf="submit && fridgestorageFormGroup.controls['fridgestorageContactAddress'].invalid"
        class="p-error">
        {{getErrorMessage(fridgestorageFormGroup, 'fridgestorageContactAddress')}}</small>
    </div>

    <div class="field col-12 lg:col-6">
      <label for="fridgestorageContactCity">
        {{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.ContactCityFieldLabel' | translate}} *
      </label>
      <input
        id="fridgestorageContactCity"
        formControlName="fridgestorageContactCity"
        type="text"
        [maxlength]="100"
        pInputText
        required
        class="custom-input"
        placeholder="{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.ContactCityFieldLabel' | translate}}"/>
      <small *ngIf="submit && fridgestorageFormGroup.controls['fridgestorageContactCity'].invalid"
        class="p-error">
        {{getErrorMessage(fridgestorageFormGroup, 'fridgestorageContactCity')}}</small>
    </div>

    <div class="field col-12 lg:col-6">
      <label for="fridgestorageContactCountryId">
        {{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.CountryFieldLabel' | translate}} *
      </label>
      <p-dropdown
        id="fridgestorageContactCountryId"
        [options]="countries"
        formControlName="fridgestorageContactCountryId"
        optionLabel="name"
        optionValue="id"
        [filter]="true"
        filterBy="name"
        [showClear]="true"
        class="custom-dropdown"
        placeholder="{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.CountryFieldPlaceholder' | translate}}"
        appendTo="body">
      </p-dropdown>
      <small *ngIf="submit && fridgestorageFormGroup.controls['fridgestorageContactCountryId'].invalid"
        class="p-error">
        {{getErrorMessage(fridgestorageFormGroup, 'fridgestorageContactCountryId')}}</small>
    </div>

    <div class="field col-12 lg:col-6">
      <label for="fridgestorageContactPhone">{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.FridgeStorageContactPhoneLabel' | translate}} *
      </label>
      <input
        id="fridgestorageContactPhone"
        formControlName="fridgestorageContactPhone"
        type="text"
        pInputText
        [maxlength]="50"
        class="custom-input"
        placeholder="{{'UserPages.UserExportOffers.NewExportOffer.NewFriedStorageModal.FridgeStorageContactPhonePlaceholder' | translate}}"/>
      <small *ngIf="submit && fridgestorageFormGroup.controls['fridgestorageContactPhone'].invalid"
        class="p-error">{{getErrorMessage(fridgestorageFormGroup, 'fridgestorageContactPhone')}}</small>
    </div>

  </div>


</form>
